const readEnv = (key, fallback = '') => {
  const raw = process.env[key];
  if (raw === undefined || raw === null) return fallback;
  const value = String(raw).trim();
  return value ? value : fallback;
};

const readEnvBool = (key, fallback = false) => {
  const raw = process.env[key];
  if (raw === undefined || raw === null) return fallback;
  const value = String(raw).trim().toLowerCase();
  if (!value) return fallback;
  if (['1', 'true', 'yes', 'y', 'on'].includes(value)) return true;
  if (['0', 'false', 'no', 'n', 'off'].includes(value)) return false;
  return fallback;
};

const normalizeBaseUrl = (value) => {
  const trimmed = String(value || '').trim();
  if (!trimmed) return '';
  return trimmed.replace(/\/+$/, '');
};

const normalizeUploadBaseUrl = (value) => {
  const base = normalizeBaseUrl(value);
  const lower = base.toLowerCase();
  if (lower.endsWith('/upload')) return base.slice(0, -'/upload'.length);
  if (lower.endsWith('/uploads')) return base.slice(0, -'/uploads'.length);
  return base;
};

const BRAND_PROFILES = {
  debians: {
    companyName: 'MultiServicios Debians',
    companyTagline: 'Tecnologia y soporte para tu negocio',
    companyEmail: 'multiserviciosdebians@gmail.com',
    hoursText: '8:00 AM a 21:00 PM',
    landingHeroAsset: 'Logo.png',
    whatsappNumber: '50236094871',
    telegramBotUsername: 'Servicio_debians_bot',
    telHref: '+50248907857',
    phoneText: '36094871  & 33648949',
    apiUrl: 'https://debiansapi.gtpos.xyz',
    uploadUrl: 'https://debiansapi.gtpos.xyz',
    felEnabled: true,
    felEstablecimiento: '5',
    pdf: {
      name: "Multiservicios Debian'S",
      addressLines: ['9 avenida 0-39, Cantón San Juan de Dios', 'Malacatán, San Marcos'],
    },
  },
    tecno: {
    companyName: 'Tecno Oh',
    companyTagline: 'Tecnologia y soporte para tu negocio',
    companyEmail: 'ventas@multiservicios.gt',
    hoursText: '8:00 AM a 18:00 PM',
    landingHeroAsset: 'landing-hero.jpg',
    whatsappNumber: '50248907857',
    telegramBotUsername: 'Servicio_debians_bot',
    telHref: '+50248907857',
    phoneText: '36094871  & 33648949',
    apiUrl: 'https://tecno-ohapi.gtpos.xyz',
    uploadUrl: 'https://tecno-ohapi.gtpos.xyz',
    felEnabled: true,
    felEstablecimiento: '1',
    pdf: {
      name: "Multiservicios Debian'S",
      addressLines: ['9 avenida 0-39, Cantón San Juan de Dios', 'Malacatán, San Marcos'],
    },
  },
  demo: {
    companyName: 'MultiServicios Debians',
    companyTagline: 'Tecnologia y soporte para tu negocio',
    companyEmail: 'multiserviciosdebians@gmail.com',
    hoursText: '8:00 AM a 21:00 PM',
    landingHeroAsset: 'Logo.png',
    whatsappNumber: '50236094871',
    telegramBotUsername: 'Servicio_debians_bot',
    telHref: '+50248907857',
    phoneText: '36094871  & 33648949',
    apiUrl: 'https://demoapi.gtpos.xyz',
    uploadUrl: 'https://demoapi.gtpos.xyz',
    felEnabled: true,
    felEstablecimiento: '5',
    pdf: {
      name: "Multiservicios Debian'S",
      addressLines: ['9 avenida 0-39, Cantón San Juan de Dios', 'Malacatán, San Marcos'],
    },
  },
};

const FEL_ESTABLECIMIENTOS = {
  '1': {
    codigoEstablecimiento: '1',
    nombreComercial: "CYBER DEBIAN'S",
    direccion: '2 AVENIDA 05-075 CANTÓN SAN MIGUEL 05-07 ZONA 1',
    codigoPostal: '12005',
    municipio: 'MALACATÁN',
    departamento: 'SAN MARCOS',
    pais: 'GT',
  },
  '2': {
    codigoEstablecimiento: '2',
    nombreComercial: 'DRINK BEER EL TARRO',
    direccion: '7 CALLE 7-008 CANTÓN MORAZAN ZONA 2',
    codigoPostal: '12005',
    municipio: 'MALACATÁN',
    departamento: 'SAN MARCOS',
    pais: 'GT',
  },
  '3': {
    codigoEstablecimiento: '3',
    nombreComercial: 'TRANSPORTES ANGEL',
    direccion: '9 AVENIDA 0-39 CANTÓN SAN JUAN DE DIOS ZONA 1',
    codigoPostal: '12005',
    municipio: 'MALACATÁN',
    departamento: 'SAN MARCOS',
    pais: 'GT',
  },
  '4': {
    codigoEstablecimiento: '4',
    nombreComercial: 'OTNY ARODY BAUTISTA ANGEL',
    direccion: '21 CALLE 13-75 ZONA 1',
    codigoPostal: '01001',
    municipio: 'GUATEMALA',
    departamento: 'GUATEMALA',
    pais: 'GT',
  },
  '5': {
    codigoEstablecimiento: '5',
    nombreComercial: "MULTISERVICIOS DEBIAN'S",
    direccion: '9 AVENIDA 0 0',
    codigoPostal: '12005',
    municipio: 'MALACATÁN',
    departamento: 'SAN MARCOS',
    pais: 'GT',
  },
};

const splitLines = (value) =>
  String(value || '')
    .split('|')
    .map((line) => line.trim())
    .filter(Boolean);

const readEnvLines = (key, fallbackLines) => {
  const lines = splitLines(process.env[key]);
  return lines.length ? lines : fallbackLines;
};

const profileKey = readEnv('REACT_APP_COMPANY_PROFILE', 'debians');
const baseProfile = BRAND_PROFILES.debians;
const rawProfile = BRAND_PROFILES[profileKey] ?? {};
const profile = {
  ...baseProfile,
  ...rawProfile,
  pdf: {
    ...baseProfile.pdf,
    ...(rawProfile.pdf ?? {}),
  },
};

const nodeEnv = String(process.env.NODE_ENV || 'development').trim() || 'development';
const isProduction = nodeEnv === 'production';

// En development, por defecto apuntar a localhost (evita usar URLs de producción por el perfil).
// En production, conservar el comportamiento actual (perfil -> env).
const apiUrlCandidate =
  readEnv('REACT_APP_API_URL_OVERRIDE', '') ||
  (isProduction
    ? profile.apiUrl || readEnv('REACT_APP_API_URL', '')
    : readEnv('REACT_APP_API_URL', '') || 'http://localhost:5002');

const apiUrl = normalizeBaseUrl(apiUrlCandidate);

const uploadUrlCandidate =
  readEnv('REACT_APP_UPLOAD_URL_OVERRIDE', '') ||
  (isProduction
    ? profile.uploadUrl || readEnv('REACT_APP_UPLOAD_URL', '')
    : readEnv('REACT_APP_UPLOAD_URL', '') || apiUrl);

const uploadUrl = normalizeUploadBaseUrl(uploadUrlCandidate) || apiUrl;

const felEnabled = readEnvBool('REACT_APP_FEL_ENABLED', profile.felEnabled ?? true);
const felEstablecimientoKey = readEnv('REACT_APP_FEL_ESTABLECIMIENTO', profile.felEstablecimiento || '1');
const felEstablecimiento =
  FEL_ESTABLECIMIENTOS[String(felEstablecimientoKey).trim()] || FEL_ESTABLECIMIENTOS['1'];

const fel = {
  enabled: felEnabled,
  url: readEnv(
    'REACT_APP_FEL_URL',
    isProduction ? 'https://apicertificacion.tekra.com.gt/servicio.php' : ''
  ),
  wsdlNamespace: readEnv(
    'REACT_APP_FEL_WSDL_NAMESPACE',
    isProduction ? 'https://apicertificacion.tekra.com.gt/certificacion/wsdl/' : ''
  ),
  frase: {
    tipoFrase: readEnv('REACT_APP_FEL_TIPO_FRASE', '3'),
    codigoEscenario: readEnv('REACT_APP_FEL_CODIGO_ESCENARIO', '1'),
    texto: readEnv('REACT_APP_FEL_FRASE_TEXTO', 'NO GENERA DERECHO A CRÉDITO FISCAL'),
  },
  emisor: {
    nit: readEnv('REACT_APP_FEL_NIT_EMISOR', '61480843'),
    nombre: readEnv('REACT_APP_FEL_NOMBRE_EMISOR', 'OTNY ARODY , BAUTISTA ANGEL'),
    afiliacionIVA: readEnv('REACT_APP_FEL_AFILIACION_IVA', 'PEQ'),
  },
  establecimiento: felEstablecimiento,
  certificador: {
    nombre: readEnv('REACT_APP_FEL_CERTIFICADOR_NOMBRE', 'TEKRA, SOCIEDAD ANÓNIMA'),
    nit: readEnv('REACT_APP_FEL_CERTIFICADOR_NIT', '107346834'),
  },
  documento: {
    titulo: readEnv('REACT_APP_FEL_DOC_TITULO', 'DOCUMENTO TRIBUTARIO ELECTRÓNICO'),
    tipo: readEnv('REACT_APP_FEL_DOC_TIPO', 'FACTURA PEQUEÑO CONTRIBUYENTE'),
  },
};

export const BRANDING = {
  apiUrl,
  uploadUrl,
  felEnabled,
  fel,
  companyName: readEnv('REACT_APP_COMPANY_NAME', profile.companyName),
  companyTagline: readEnv('REACT_APP_COMPANY_TAGLINE', profile.companyTagline),
  companyEmail: readEnv('REACT_APP_COMPANY_EMAIL', profile.companyEmail),

  hoursText: readEnv('REACT_APP_COMPANY_HOURS_TEXT', profile.hoursText || ''),
  landingHeroAsset: readEnv('REACT_APP_LANDING_HERO_ASSET', profile.landingHeroAsset || ''),

  whatsappNumber: readEnv('REACT_APP_WHATSAPP_NUMBER', profile.whatsappNumber),
  telegramBotUsername: readEnv('REACT_APP_TELEGRAM_BOT_USERNAME', profile.telegramBotUsername || ''),
  telHref: readEnv('REACT_APP_COMPANY_TEL_HREF', profile.telHref),
  phoneText: readEnv('REACT_APP_COMPANY_PHONE_TEXT', profile.phoneText),

  pdf: {
    name: readEnv('REACT_APP_COMPANY_PDF_NAME', profile.pdf.name),
    addressLines: readEnvLines('REACT_APP_COMPANY_ADDRESS_LINES', profile.pdf.addressLines),
  },
};
